export default __webpack_public_path__ + "static/media/AG02.c720e2e5.mp3";